import { Measure } from '../../../api/work-periods-client/work-periods-client.type';
import type { KPIConfig } from './overview.type';

const KPI_CONFIGS: KPIConfig[] = [
  {
    id: 'throughput',
    titleKey: 'process_analysis.kpi.total_throughput',
    icon: 'trending_up',
    measure: Measure.Throughput,
    unitKey: 'common.work_units',
    aggregation: 'sum',
  },
  {
    id: 'cycle_time',
    titleKey: 'process_analysis.kpi.average_cycle_time',
    icon: 'timer',
    measure: Measure.CycleTime,
    unitKey: 'process_analysis.kpi.unit_days',
    aggregation: 'average',
  },
  {
    id: 'quality',
    titleKey: 'process_analysis.kpi.quality_allocation',
    icon: 'verified',
    measure: Measure.Quality,
    unitKey: 'process_analysis.kpi.unit_percentage',
    aggregation: 'average',
  },
  {
    id: 'strategy',
    titleKey: 'process_analysis.kpi.strategic_allocation',
    icon: 'account_tree',
    measure: Measure.Strategy,
    unitKey: 'process_analysis.kpi.unit_percentage',
    aggregation: 'average',
  },
];

export { KPI_CONFIGS };
